import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PagingOptions,
  RestoreTaskId,
  RestoreWebsite,
  RestoreDatabase,
  RestoreServer,
  RestoreTaskSummaryDTO,
  QueryResultDTO,
} from '../../shared/models/backups.models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestoreTaskService {
  private http = inject(HttpClient);

  baseURL = '/backups/tasks/restores';

  searchRestoreTasks(query: PagingOptions): Observable<QueryResultDTO<RestoreTaskSummaryDTO>> {
    let params = new HttpParams()
      .set('page', query.page)
      .set('pageSize', query.pageSize)
      .set('websiteId', query.websiteId!);

    if (query.timestampFrom) params = params.set('timestampFrom', query.timestampFrom);
    if (query.timestampTo) params = params.set('timestampTo', query.timestampTo);

    return this.http.get<[RestoreTaskSummaryDTO[], number]>(this.baseURL, { params }).pipe(
      map(([data, total]) => ({
        data,
        total,
      })),
    );
  }

  getRestoreTask(id: RestoreTaskId): Observable<RestoreTaskSummaryDTO> {
    return this.http.get<RestoreTaskSummaryDTO>(`${this.baseURL}/${id}`);
  }

  getWebsiteRestoreData(id: RestoreTaskId): Observable<RestoreWebsite> {
    return this.http.get<RestoreWebsite>(`${this.baseURL}/${id}/websites`);
  }

  getDatabaseRestoreData(id: RestoreTaskId): Observable<RestoreDatabase> {
    return this.http.get<RestoreDatabase>(`${this.baseURL}/${id}/databases`);
  }

  getServerRestoreData(id: RestoreTaskId): Observable<RestoreServer> {
    return this.http.get<RestoreServer>(`${this.baseURL}/${id}/servers`);
  }
}
